export interface PermissionLandingRoute {
    /** Omit for a page every logged-in user can open. */
    module?: string;
    route: string;
}

/**
 * After login the user lands on the first route here whose module they can view.
 * Module names are matched against the login `Permission[]` codes (see login-response.mapper.ts).
 * Add one entry per feature, in priority order.
 */
export const PERMISSION_LANDING_ROUTES: PermissionLandingRoute[] = [
    {route: '/dashboard'},
    {module: 'Projects', route: '/projects'},
    {module: 'Sites', route: '/sites'},
    {module: 'MaterialMapping', route: '/material-mapping'},
    {module: 'Materials', route: '/materials'},
    {module: 'BOQ', route: '/boq'},
    {module: 'MaterialInward', route: '/material-inward'},
    {module: 'StockTracking', route: '/stock-tracking'},
    {module: 'Consumption', route: '/consumption'},
    {module: 'Salary', route: '/salary-master'},
    {module: 'SubContractors', route: '/subcontractors'},
    {module: 'SubContractorCategoryMaster', route: '/sub-contractor-category-master'},
    {module: 'UserList', route: '/users'},
    {module: 'Employees', route: '/employees'},
    {module: 'EmployeeProjectMapping', route: '/employee-project-mapping'},
    {module: 'ProjectCostSummaryReport', route: '/reports/project-cost-summary'},
    {module: 'ProfitLossAnalysis', route: '/profit-loss'},
    {module: 'BoqProfitLossReport', route: '/reports/boq-profit-loss'},
    {module: 'MaterialStockReport', route: '/reports/material-stock'},
    {module: 'MaterialConsumptionReport', route: '/reports/material-consumption'},
    {module: 'ConsumptionCostReport', route: '/reports/consumption'},
    {module: 'SubContractorCostReport', route: '/reports/contractor-cost'},
    {module: 'EmployeeProjectAssignmentReport', route: '/reports/employee-project-assignment'},
    {module: 'UnitMaster', route: '/unit-master'},
    {module: 'MaterialCategoryMaster', route: '/material-category-master'},
    {module: 'MaterialSubCategoryMaster', route: '/material-sub-category-master'},
    {module: 'ConsumptionCategoryMaster', route: '/consumption-category-master'},
    {module: 'LanguageMaster', route: '/language-master'},
    {module: 'LanguageConfig', route: '/language-config'},
    {module: 'ImportExportLog', route: '/audit-log/import-export-log'},
    {module: 'ConsumptionLog', route: '/audit-log/consumption-log'},
];

/**
 * Backend permission name → our module name, for names that don't already match after
 * ignoring case, spaces and punctuation (e.g. "Material Mapping" already matches "MaterialMapping").
 * Example: `'Sub Contractor Master': 'SubContractors'`.
 */
export const PERMISSION_MODULE_ALIASES: Record<string, string> = {
    Site: 'Sites',
    Material: 'Materials',
    'Material Master': 'Materials',
    BOQs: 'BOQ',
    'Language Configuration': 'LanguageConfig',
    'Employee Master': 'Employees',
    Employee: 'Employees',
    Language: 'LanguageMaster',
    Languages: 'LanguageMaster',
    'Profit and Loss': 'ProfitLoss',
    'BOQ Profit and Loss Report': 'BoqProfitLossReport',
    'Sub Contractor Category': 'SubContractorCategoryMaster',
    'Sub Contractor Categories': 'SubContractorCategoryMaster',
    'Subcontractor Category Master': 'SubContractorCategoryMaster',
    'Subcontractor Category': 'SubContractorCategoryMaster',
    'Subcontractor Categories': 'SubContractorCategoryMaster',
    'Import and Export log': 'ImportExportLog',
};
